<template>
  <view class="network-err flex-row center column w100">
    <image
      src="https://image.kuaizilife.com/upload/common/6ccd9a426034900bae2362fc2d3bf744.png"
      class="icon"
      mode="aspectFill"
    ></image>
    <view class="color6 font28 tips">网络出了点问题，请刷新重试~</view>
    <view class="color-theme btn flex-row center font28" @click="handleRefresh">刷新</view>
  </view>
</template>

<script setup lang="ts">
// 刷新
const handleRefresh = () => {
  let pages: any = getCurrentPages()
  let target = pages[pages.length - 2]
  if (pages[pages.length - 1].route === 'networkErr/index') {
    let url = `/${target.route}`
    if (target.options) {
      let inx = 0
      for (const key in target.options) {
        url += inx === 0 ? '?' : '&'
        url += `${key}=${target.options[key]}`
        inx++
      }
    }
    uni.redirectTo({ url })
  } else {
    location.reload()
  }
}
</script>

<style lang="scss" scoped>
.network-err {
  height: calc(100vh - calc((88rpx * 2) + env(safe-area-inset-top)));
  .icon {
    width: 240rpx;
    height: 240rpx;
  }

  .tips {
    padding-top: 20rpx;
  }

  .btn {
    margin-top: 32rpx;
    width: 176rpx;
    height: 72rpx;
    border-radius: 36rpx;
    border: 2rpx solid #ff4725;
  }
}
</style>
